<div class="row">
	<div class="col-12 col-lg-3">
		<app-gen-autocomplete
			#searchFuzzy
			title_ph_lang="patient"
			[fuzzySearchableClasses]="['patients']"
			(chosenEvent)="choosePatient($event)"
		>
		</app-gen-autocomplete>
	</div>
</div>
<app-spin-or-content [isSpin]="isFetching">
	<table class="table table-hover pad-block followups-update-list">
		<thead>
			<tr>
				<th
					(click)="sort('patient_name')"
					sorter
					fieldName="patient_name"
					[displayName]="'patient_name' | langVal"
					[sortField]="sortField"
					[sortIsAsc]="sortIsAsc"
				></th>

				@if (permsService?.owner_has_users) {
					<th>{{ "locations" | langVal }}</th>
					<th>{{ "sub_users_therpaists" | langVal }}</th>
				}
				<th
					(click)="sort('date')"
					sorter
					fieldName="date"
					[displayName]="'date' | langVal"
					[sortField]="sortField"
					[sortIsAsc]="sortIsAsc"
				></th>
				<th>{{ "time" | langVal }}</th>
				<th
					(click)="sort('meetingtype_id')"
					sorter
					fieldName="meetingtype_id"
					[displayName]="'meetingtype' | langVal"
					[sortField]="sortField"
					[sortIsAsc]="sortIsAsc"
				></th>
				<th>{{ "price" | langVal }}</th>
				<th
					(click)="sort('payor_id')"
					sorter
					fieldName="payor_id"
					[displayName]="'payor' | langVal"
					[sortField]="sortField"
					[sortIsAsc]="sortIsAsc"
				></th>

				<th>{{ "price_payor" | langVal }}</th>
				@if (permsService?.owner_has_users) {
					<th>{{ "price_for_meeting" | langVal }}</th>
				}
				<th>{{ "arrived" | langVal }}</th>
				<th>{{ "charged" | langVal }}</th>
				@if (isManualChargeShown == "yes") {
					<th>{{ "charged_manualy" | langVal }}</th>
				}
				<th>{{ "takes_place" | langVal }}</th>
				<th
					(click)="sort('no_description')"
					sorter
					fieldName="no_description"
					[displayName]="'no_description' | langVal"
					[sortField]="sortField"
					[sortIsAsc]="sortIsAsc"
				>
					{{ "no_description" | langVal }}
				</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			@for (row of objectCollectionShown; track row) {
				@if (row.isNewDate) {
					<tr>
						<td
							colspan="99999"
							style="font-size: 18px"
						>
							{{ row.date | dateFormat }}
						</td>
					</tr>
				}
				<tr class="followups-list-tr">
					<td class="link-patient">
						@if (permsService?.perms?.clinical) {
							<app-followup-modal [id]="row.id">
								<div class="static">{{ row.patient_name }}</div>
							</app-followup-modal>
						} @else {
							<app-patient-modal [id]="row.patient_id">
								<div class="static">{{ row.patient_name }}</div>
							</app-patient-modal>
						}
					</td>
					@if (permsService?.owner_has_users) {
						<td>{{ row.location_name }}</td>
						<td>
							<div class="static">{{ row.assoc }}</div>
						</td>
					}
					<td style="width: 20px">
						<div class="static">{{ row.date | dateFormat }}</div>
					</td>
					<td style="width: 20px">
						<div class="static">{{ row.time | timeFormat }}</div>
					</td>
					<td style="overflow: inherit">
						@if (row.meetingtype_id == -1) {
							{{ "former_debt" | langVal }}
						} @else {
							<app-gen-autocomplete
								[actualObj]="row"
								fieldName="meetingtype_id"
								tabindex="-1"
								title_ph_lang="meetingtype"
								[fuzzySearchableClasses]="['meetingtypes']"
								(chosenEvent)="onMeetingtypeChange(row)"
							/>
						}

						<!-- <div class="static colstat-price">{{ row.meetingtype_name }}</div> -->
					</td>
					<td>
						<div class="colstat-price">
							<app-gen-input
								[actualObj]="row"
								fieldName="price"
								[disabled]="store.hasInvoiceIdPerson(row)"
								[placeholder]="row.price ? row.price : ('price' | langVal)"
								(changeEvent)="saveFollowup(row)"
							>
							</app-gen-input>
						</div>
					</td>

					<td style="overflow: inherit">
						<div>
							<app-gen-autocomplete
								title_ph_lang="payor"
								[actualObj]="row"
								fieldName="payor_id"
								[disabled]="store.hasInvoiceIdPerson(row)"
								tabindex="-1"
								[fuzzySearchableClasses]="['payors']"
								(chosenEvent)="saveFollowup(row)"
							></app-gen-autocomplete>
						</div>
					</td>
					<td>
						<div class="colstat-price">
							<app-gen-input
								[actualObj]="row"
								fieldName="price_payor"
								(changeEvent)="saveFollowup(row)"
							/>
						</div>
					</td>
					@if (permsService?.owner_has_users) {
						<td>
							<div class="colstat-price">
								<app-gen-input
									[actualObj]="row"
									fieldName="sub_user_tarif"
									title_ph_lang="tarif"
									(changeEvent)="saveFollowup(row)"
								>
								</app-gen-input>
							</div>
						</td>
					}
					<td>
						@if (row.is_group == "no") {
							<div class="colstat-price">
								<app-yes-no
									(onClick)="changeYesNo(row, 'arrived')"
									[isCheck]="row.arrived == 'yes'"
								></app-yes-no>
							</div>
							<!-- toKeep @if(row.is_group){
              <button (click)="openGroupAttendModal()"
                      class="btn btn-primary">{{(hasNonAttend ? "part" : "all_arrived") | langVal}}</button>
              <button (click)="openGroup()" titleLang="groups_long"
                      class="btn btn-primary">{{"group_details" | langVal}}</button>
              } -->
						}
					</td>

					<td>
						@if (
							store.hasInvoiceIdPerson(row) || store.hasInvoiceIdPayor(row)
						) {
							<div class="d-flex paid">
								@if (store.hasInvoiceIdPerson(row)) {
									<div class="text-wrap">
										{{
											row?.invoice_id_patient > 0
												? ("paid_by_finresource" | langVal) +
													row.invoice_id_patient
												: ("paid" | langVal)
										}}
									</div>
								}
								@if (store.hasInvoiceIdPayor(row)) {
									<div>
										{{
											row?.invoice_id_payor > 0
												? ("paid_by_finresource" | langVal) +
													row.invoice_id_payor
												: ("paid" | langVal)
										}}
									</div>
								}
							</div>
						} @else {
							<app-yes-no
								(onClick)="changeYesNo(row, 'charged')"
								[isCheck]="row.charged == 'yes'"
							/>
						}
					</td>
					@if (isManualChargeShown == "yes") {
						<td>
							@if (
								row.patient_id &&
								(row.is_group == "no" || row.charge_mode == "by_group")
							) {
								<div class="colstat-big">
									<app-yes-no
										(onClick)="changeYesNo(row, 'charged_manualy')"
										[isCheck]="row.charged_manualy == 'yes'"
									/>

									@if (row.charged_manualy == "yes") {
										<app-gen-input
											[actualObj]="row"
											fieldName="invoice_id"
											[disabled]="store.hasInvoiceIdPerson(row)"
											[placeholder]="'external_invoice_id' | langVal"
											(changeEvent)="saveFollowup(row)"
										>
										</app-gen-input>
									}
								</div>
							}
						</td>
					}
					<td>
						<div class="colstat-price">
							<app-yes-no
								(onClick)="changeYesNo(row, 'takes_place')"
								[isCheck]="row.takes_place == 'yes'"
							></app-yes-no>
						</div>
					</td>
					<td>
						<div
							class="colstat-price"
							style="color: red"
						>
							{{ row.no_description ? "*" : "" }}
						</div>
					</td>

					<td>
						@if (row.patient_id) {
							@if (row.is_group == "no" || row.charge_mode == "by_group") {
								@if (
									permsService.perms?.administrative ||
									permsService.perms?.clinic_financial
								) {
									<button
										class="btn btn-icon"
										titleLang="invoice_short"
										(click)="addInvoice(row)"
										tabindex="-1"
										preIcon="invoice-plus"
										isImg
									></button>
								}
							} @else {
								<button
									(click)="openGroupAttendModal(row)"
									class="btn btn-primary"
								>
									{{ "group_attendancy" | langVal }}
								</button>
							}
						}
					</td>
				</tr>
				@if (
					enable_invoice_number_edit &&
					(row.invoice_id_patient || row.invoice_id_payor)
				) {
					<tr>
						@if (row.invoice_id_patient) {
							<td>
								<app-btn-ext
									(clickEv)="resetValue(row, true)"
									text="reset_invoice_patient"
								/>
							</td>
						}
						@if (row.invoice_id_payor) {
							<td>
								<app-btn-ext
									(clickEv)="resetValue(row, false)"
									text="reset_invoice_payor"
								/>
							</td>
						}
					</tr>
				}
			}
		</tbody>
	</table>
	@if (!hasReceivedExtended) {
		<div class="modal-btns justify-content-center">
			<app-btn-ext
				text="extra_2_months_back"
				[isSpin]="isFetchingExtended"
				(clickEv)="getExtended()"
			/>
		</div>
	}
</app-spin-or-content>

@switch (modalProps?.name) {
	@case ("add-invoice") {
		<app-add-invoice
			(onClose)="modalProps = null"
			[description]="modalProps.description"
			[paid_by]="modalProps.row.patient_name"
			[for]="modalProps.row.patient_name"
			resource="patient"
			[resourceId]="modalProps.row.patient_id"
		/>
	}
	@case ("group-attends") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="group_attendancy"
			modalWrapperClass="modal-800"
		>
			<app-group-attends
				(onClose)="modalProps = null"
				[group_id]="modalProps.group_id"
				[followup_id]="modalProps.followup_id"
			/>
		</app-modal-wrap>
	}
}
